import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Aboutcard from "./AboutCard";
import SkillCarousel from "./SkillCarousel";
import laptopImg from "../../Assets/about.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          gap: "20px",
          flexWrap: "wrap",
          marginBottom: "20px"
        }}>
          <h1 className="project-heading" style={{ margin: 0 }}>
            Professional <strong className="purple">Skills & Tools </strong>
          </h1>
          <a href="/skills-ai" className="ai-skills-btn">
            <span className="ai-icon">🤖</span>
            Click Here
            <span className="sparkle">✨</span>
          </a>
        </div>
        
        <SkillCarousel />

        <Github />
      </Container>
    </Container>
  );
}

export default About;